import { render, staticRenderFns } from "./Modal.Confirm.vue?vue&type=template&id=25aabc10&"
import script from "./Modal.Confirm.vue?vue&type=script&lang=js&"
export * from "./Modal.Confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports